import { Button } from '@packages/shared/src/ui/Button/Button';
import { defineMessage, useIntl } from 'react-intl';
import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import { dispatchButtonTracking } from '@packages/shared/src/ui/Button/dispatchButtonTracking';
import type { ButtonHTMLAttributes } from 'react';
import { buttonStylingTailwind } from './Actions.styles';

export interface BasketEditActionProps {
  mode: 'basket';
}

export interface WishlistEditActionProps {
  mode: 'wishlist';
}

export type EditActionProps = BasketEditActionProps | WishlistEditActionProps;

const message = defineMessage({
  id: 'EditAction.ButtonText',
  defaultMessage: 'Ändern',
  description: 'this will be displayed on the button',
});

export const EditAction: React.FC<
  EditActionProps & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'color'>
> = ({ onClick, ...props }) => {
  const { formatMessage } = useIntl();
  const dispatchGlycerin = useTracking();

  const onClickHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    dispatchButtonTracking({
      eventDispatcher: dispatchGlycerin,
      type: 'button',
      clickTrackingProps: {
        category: 'Artikel Ändern',
        label: 'Produktkonfiguration',
      },
    });
    onClick?.(event);
  };

  return (
    <Button
      className={buttonStylingTailwind}
      onClick={onClickHandler}
      data-testid="edit-action"
      variant="icon-flat"
      size="base"
      {...props}
    >
      <div className="icon-emp-edit size-4 md:size-3" />
      {formatMessage(message)}
    </Button>
  );
};
